import { createActions } from 'redux-actions';

const ModalActions = createActions({
  SET_SHOW_MODAL: (show) => ({ show }),
  SET_SHOW_SIDEBAR: (openSidebar) => ({ openSidebar }),
  CLEAR: () => {},
});

export default ModalActions;
